export default __webpack_public_path__ + "static/media/bunny-map.84aaf3f7.png";